import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RoomPopupStateType } from './types';

const initialState: RoomPopupStateType = {
  isOpened: false,
  packageId: null,
};

export const roomPopupSlice = createSlice({
  name: 'roomPopup',
  initialState,
  reducers: {
    openRoomPopup(state, action: PayloadAction<number>) {
      state.isOpened = true;
      state.packageId = action.payload;
    },
    closeRoomPopup() {
      return { ...initialState };
    },
  },
});
